import { Events } from '@ezchops/helpers';
import { isChannelMessage, parseMidiMessageData } from '../web';
export class WebMidiInputAdapter extends Events.EventEmitter {
    input;
    messageAdapter;
    constructor(input) {
        super();
        this.input = input;
        this.messageAdapter = new MidiMessageAdapter();
        input.addEventListener('statechange', this.handleStateChange);
        input.addEventListener('midimessage', this.handleMidiMessage);
    }
    get isConnected() {
        return this.input.state == 'connected';
    }
    close() {
        // @ts-expect-error
        this.input.removeEventListener('statechange', this.handleStateChange);
        // @ts-expect-error
        this.input.removeEventListener('midimessage', this.handleMidiMessage);
    }
    handleMidiMessage = (event) => {
        const data = Array.from(event.data);
        const timestamp = event.timeStamp;
        const message = { kind: 'message', timestamp, data };
        this.emit('message', message);
        const midiEvent = this.messageAdapter.getMidiEvent(message);
        if (midiEvent != null) {
            this.emit(midiEvent.kind, midiEvent);
        }
    };
    handleStateChange = (e) => {
        const port = e.port;
        if (this.input != port) {
            throw new Error('Input changed');
        }
        if (e.port.connection == 'open') {
            this.emit('opened', e.timeStamp);
        }
        else if (e.port.connection == 'closed' && e.port.state === 'connected') {
            this.emit('closed', e.timeStamp);
        }
        else if (e.port.connection == 'closed' && e.port.state === 'disconnected') {
            this.emit('disconnected', e.timeStamp);
        }
        else if (e.port.connection == 'pending' && e.port.state === 'disconnected') {
        }
        else {
            console.warn('This statechange event was not caught', {
                connection: e.port.connection,
                state: e.port.state
            });
        }
    };
    get label() {
        return WebMidiInputAdapter.inputLabel(this.input);
    }
    get drumModule() {
        return WebMidiInputAdapter.inputModule(this.input);
    }
    static inputLabel(input) {
        return (input.manufacturer || input.name || input.version)
            ? `${input.manufacturer} ${input.name} ${input.version}`
            : 'Unknown midi';
    }
    static inputModule(input) {
        return {
            manufacturer: input.manufacturer,
            name: input.name,
            version: input.version
        };
    }
}
export class MidiMessageAdapter {
    getMidiEvent = ({ data, timestamp }) => {
        const message = parseMidiMessageData(data);
        const type = message.type;
        if (!isChannelMessage(message)) {
            if (type == 'clock') {
                return { kind: 'clock', timestamp };
            }
            else {
                return undefined;
            }
        }
        else if (type == 'noteoff' || (type == 'noteon' && message.dataBytes[1] === 0)) {
            return this.extractNoteOff(message, timestamp);
        }
        else if (type == 'noteon') {
            return this.extractNoteOn(message, timestamp);
        }
        else if (type == 'controlchange') {
            return this.extractControlChange(message, timestamp);
        }
    };
    extractNoteOff = (message, timestamp) => {
        const note = message.dataBytes[0] & 0x7f;
        const velocity = message.dataBytes[1] & 0x7f;
        return { kind: 'noteoff', timestamp, note, velocity };
    };
    extractNoteOn(message, timestamp) {
        const note = message.dataBytes[0] & 0x7f;
        const velocity = message.dataBytes[1] & 0x7f;
        return { kind: 'noteon', timestamp, note, velocity };
    }
    extractControlChange(message, timestamp) {
        const control = message.dataBytes[0] & 0x7f;
        const value = message.dataBytes[1] & 0x7f;
        return { kind: 'controlchange', timestamp, control, value };
    }
}
//# sourceMappingURL=WebMidiInputAdapter.js.map